import React from 'react';
import { useSelector } from 'react-redux';
import { CenterContainer } from './styles';
import { UNDER_REVIEW_PAGE } from './utils';
import { CommonButton } from '@Components';
import { APPROVE_NEW_ICON } from '@Images';
import { useNavigate } from 'react-router-dom';
import { DASHBOARD_URL } from '@Utils/constants';
import { getRfiCmsData } from '@Redux/selectors';

const UnderReviewPage: React.FC = () => {
  const navigate = useNavigate();
  const underReviewPageCMSData = useSelector(getRfiCmsData)?.ekycRFI?.underReviewPage;
  const { heading, description, goToHomeCTA } = underReviewPageCMSData ?? UNDER_REVIEW_PAGE;

  const handleGoToHome = () => {
    navigate(DASHBOARD_URL);
  };
  return (
    <CenterContainer>
      <div className="innerContainer">
        <div className="img">
          <img src={APPROVE_NEW_ICON} alt="Check mark Icon" />
        </div>
        <div className="heading">{heading}</div>
        <div className="description">{description}</div>
        <div className="btnWrapper">
          <CommonButton text={goToHomeCTA} onClick={handleGoToHome} type="link" />
        </div>
      </div>
    </CenterContainer>
  );
};

export default UnderReviewPage;
